import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Loader } from "rsuite";
import LoadingMessageBox from "../LoadingMessgeBox/LoadingMessageBox";
import "./MessageListContainer.css";

const MessageListContainer = ({
  children,
  isEmpty,
  isLoading,
  isLoadingNewMessage,
}) => {
  const { t } = useTranslation();
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) {
      ref.current.scrollTop = ref.current.scrollHeight;
    }
  }, [children]);

  return (
    <div ref={ref} className="chat-message-list-container__root">
      {isLoading && (
        <div className="chat-message-list-container__empty-container">
          <Loader />
        </div>
      )}
      {isEmpty && !isLoading && (
        <div className="chat-message-list-container__empty-container">
          {t("What can I help with?")}
        </div>
      )}
      {!isEmpty && !isLoading && children}
      {isLoadingNewMessage && !isLoading && <LoadingMessageBox />}
    </div>
  );
};

export default MessageListContainer;
